import { colors } from "../DEPRECATED/colors"

export const top = `
  border-top: 1px solid ${colors.grey.$300};
`

export const bottom = `
  border-bottom: 1px solid ${colors.grey.$300};
`

export const left = `
  border-left: 1px solid ${colors.grey.$300};
`

export const right = `
  border-right: 1px solid ${colors.grey.$300};
`
